import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

const getValidToken = () => {
  const token = localStorage.getItem("token");
  const isValid =
    token && token !== "undefined" && token !== "null" && token.trim() !== "";

  if (!isValid) {
    localStorage.removeItem("token");
    return null;
  }
  return token;
};

export default function Home() {
  const navigate = useNavigate();
  const location = useLocation();

  const [notice, setNotice] = useState({ text: "", type: "" });

  useEffect(() => {
    const stateReason = location?.state?.reason;

    if (stateReason === "auth_required") {
      setNotice({
        text: "Você precisa entrar para acessar essa área.",
        type: "error",
      });

      navigate(location.pathname, { replace: true, state: {} });
      return;
    }

    const stored = localStorage.getItem("authNotice");
    if (stored) {
      setNotice({ text: stored, type: "error" });
      localStorage.removeItem("authNotice");
    }
  }, [location.key, location.pathname, location.state, navigate]);

  useEffect(() => {
    const token = getValidToken();
    if (token) {
      navigate("/app/home", { replace: true });
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#FAFAFC] text-[#24152F] antialiased selection:bg-[#ECE7FA]">
      {/* Banner de aviso / notificação */}
      {notice.text && (
        <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50 w-full max-w-md px-4 animate-in fade-in slide-in-from-top-4 duration-300">
          <div className="rounded-2xl border border-red-200 bg-red-50/95 backdrop-blur-md px-4 py-3 text-center text-xs font-bold text-red-700 shadow-xl flex items-center justify-between gap-2">
            <span>{notice.text}</span>
            <button
              onClick={() => setNotice({ text: "", type: "" })}
              className="text-red-500 hover:text-red-800 p-1"
            >
              ✕
            </button>
          </div>
        </div>
      )}

      {/* NAVBAR NÍTIDA */}
      <header className="sticky top-0 z-40 w-full border-b border-[#ECE7FA] bg-white/95 backdrop-blur-md shadow-[0_2px_10px_rgba(36,21,47,0.03)]">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 sm:px-6 py-3.5">
          <Link to="/" className="flex items-center gap-2.5 group">
            <div className="flex h-9 w-9 items-center justify-center rounded-2xl bg-[#6C54D8] text-white font-black text-lg shadow-sm group-hover:scale-105 transition-transform">
              m
            </div>
            <span className="text-xl font-bold tracking-tight text-[#24152F]">
              mariam
            </span>
          </Link>

          <div className="flex items-center gap-3">
            <Link
              to="/login"
              className="btn-secondary text-xs font-bold h-10 px-5"
            >
              Entrar
            </Link>
            <Link
              to="/register"
              className="btn-primary text-xs font-bold h-10 px-5 shadow-md"
            >
              Criar Conta
            </Link>
          </div>
        </div>
      </header>

      {/* HERO SECTION ILUSTRADA */}
      <section className="relative overflow-hidden pt-8 pb-16 md:pt-14 md:pb-24 bg-gradient-to-b from-[#ECE7FA]/40 via-[#FAFAFC] to-[#FAFAFC]">
        {/* Elementos Orbes Liti */}
        <div className="absolute top-10 left-1/2 -translate-x-1/2 h-[450px] w-[450px] rounded-full bg-[#CBF1DB]/25 blur-3xl pointer-events-none" />
        <div className="absolute top-40 right-10 h-80 w-80 rounded-full bg-[#6C54D8]/15 blur-3xl pointer-events-none" />

        <div className="relative z-10 mx-auto max-w-6xl px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            
            {/* LADO ESQUERDO - CHAMADA PRINCIPAL */}
            <div className="lg:col-span-7 text-center lg:text-left space-y-6">
              <div className="inline-flex items-center gap-2 rounded-full bg-[#CBF1DB] px-4 py-1.5 text-xs font-bold text-[#24152F] shadow-xs">
                <span className="flex h-2.5 w-2.5 rounded-full bg-[#6C54D8] animate-pulse" />
                Saúde, bem-estar e resultados reais
              </div>

              <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-[#24152F] leading-[1.15] font-serif">
                Cuidar de você não precisa ser{" "}
                <span className="text-[#6C54D8] italic">
                  complicado.
                </span>
              </h1>

              <p className="text-sm sm:text-base text-[#6D6680] font-medium leading-relaxed max-w-2xl mx-auto lg:mx-0">
                Organize suas medicações, doses de caneta injetável, consumo diário de água, registro de peso e diário pessoal em uma única plataforma simples e acolhedora.
              </p>

              <div className="pt-2 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3.5">
                <Link
                  to="/register"
                  className="btn-primary w-full sm:w-auto h-12 px-8 text-sm font-bold shadow-lg shadow-[#6C54D8]/20 flex items-center justify-center gap-2"
                >
                  Começar Agora Grátis
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </Link>

                <Link
                  to="/login"
                  className="btn-secondary w-full sm:w-auto h-12 px-7 text-sm font-bold"
                >
                  Já tenho uma conta
                </Link>
              </div>

              <div className="pt-3 flex items-center justify-center lg:justify-start gap-6 text-xs font-bold text-[#6D6680]">
                <span className="flex items-center gap-1.5">
                  <svg className="w-4 h-4 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                  </svg>
                  Gratuito & 100% Privado
                </span>
                <span className="flex items-center gap-1.5">
                  <svg className="w-4 h-4 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                  </svg>
                  Celular e Computador
                </span>
              </div>
            </div>

            {/* LADO DIREITO - MOCKUP REAL DA APLICAÇÃO */}
            <div className="lg:col-span-5 relative">
              <div className="relative mx-auto max-w-sm lg:max-w-none">
                
                {/* CONTAINER CARD DE PREVIEW MOCKUP */}
                <div className="liti-card rounded-[28px] p-5 shadow-2xl border border-[#ECE7FA] bg-white space-y-3">
                  
                  {/* Topo do Mockup */}
                  <div className="flex items-center justify-between border-b border-[#ECE7FA] pb-3">
                    <div className="flex items-center gap-2.5">
                      <div className="h-9 w-9 rounded-2xl bg-[#6C54D8] text-white flex items-center justify-center font-bold text-sm">
                        m
                      </div>
                      <div>
                        <h4 className="text-xs font-bold text-[#24152F] tracking-tight">MariaM App</h4>
                        <p className="text-[10px] text-[#6D6680] font-medium">Sua rotina hoje</p>
                      </div>
                    </div>
                    <span className="rounded-full bg-[#CBF1DB] text-[#24152F] text-[10px] font-bold px-2.5 py-0.5">
                      Ao vivo
                    </span>
                  </div>

                  {/* Card 1: Dose do Dia */}
                  <div className="rounded-2xl bg-[#FAFAFC] p-3 border border-[#ECE7FA] flex items-center justify-between gap-2">
                    <div className="flex items-center gap-3 min-w-0">
                      <div className="h-9 w-9 rounded-xl bg-[#ECE7FA] text-[#6C54D8] flex items-center justify-center text-base shrink-0 font-bold">
                        💉
                      </div>
                      <div className="min-w-0">
                        <p className="text-xs font-bold text-[#24152F] truncate">Mounjaro / Ozempic</p>
                        <p className="text-[10px] text-[#6D6680]">Dose: 2.5 mg às 19:00</p>
                      </div>
                    </div>
                    <span className="inline-flex items-center gap-1 rounded-full bg-[#CBF1DB] px-2.5 py-1 text-[10px] font-bold text-[#24152F] shrink-0">
                      Tomada 🎉
                    </span>
                  </div>

                  {/* Card 2: Hidratação */}
                  <div className="rounded-2xl bg-[#DCEEFF]/60 p-3 border border-[#6C54D8]/20 flex items-center justify-between gap-2">
                    <div className="flex items-center gap-3 min-w-0">
                      <div className="h-9 w-9 rounded-xl bg-[#DCEEFF] text-[#6C54D8] flex items-center justify-center text-base shrink-0 font-bold">
                        💧
                      </div>
                      <div className="min-w-0">
                        <p className="text-xs font-bold text-[#24152F] truncate">Hidratação do Dia</p>
                        <p className="text-[10px] text-[#6C54D8] font-medium">6 de 8 copos (1.500 ml)</p>
                      </div>
                    </div>
                    <span className="text-xs font-extrabold text-[#6C54D8] shrink-0">75%</span>
                  </div>

                  {/* Card 3: Peso & Medidas */}
                  <div className="rounded-2xl bg-[#FAFAFC] p-3 border border-[#ECE7FA] flex items-center justify-between gap-2">
                    <div className="flex items-center gap-3 min-w-0">
                      <div className="h-9 w-9 rounded-xl bg-[#ECE7FA] text-[#6C54D8] flex items-center justify-center text-base shrink-0 font-bold">
                        ⚖️
                      </div>
                      <div className="min-w-0">
                        <p className="text-xs font-bold text-[#24152F]">Evolução de Peso</p>
                        <p className="text-[10px] text-[#6D6680]">Atual: 84,2 kg (Meta: 78 kg)</p>
                      </div>
                    </div>
                    <span className="rounded-full bg-[#CBF1DB] px-2.5 py-0.5 text-[10px] font-bold text-emerald-800 shrink-0">
                      -4,3 kg
                    </span>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* SEÇÃO DE RECURSOS / RECURSOS PRINCIPAIS */}
      <section className="py-16 bg-white border-t border-b border-[#ECE7FA]">
        <div className="mx-auto max-w-6xl px-4 sm:px-6">
          
          <div className="text-center max-w-2xl mx-auto mb-12">
            <h2 className="text-xs font-bold uppercase tracking-wider text-[#6C54D8] mb-1">
              Tudo em um só lugar
            </h2>
            <p className="text-2xl sm:text-3xl font-bold text-[#24152F] font-serif tracking-tight">
              Recursos essenciais para o seu acompanhamento
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            
            {/* Card 1 */}
            <div className="liti-card p-5 space-y-3 transition-all duration-300 hover:-translate-y-1">
              <div className="h-12 w-12 rounded-2xl bg-[#ECE7FA] text-[#6C54D8] flex items-center justify-center text-xl font-bold">
                💉
              </div>
              <h3 className="text-sm font-bold text-[#24152F]">Canetas & Remédios</h3>
              <p className="text-xs text-[#6D6680] leading-relaxed">
                Controle de dosagem por mg/cápsula, agendamento de doses únicas ou recorrentes e baixa automática de estoque.
              </p>
            </div>

            {/* Card 2 */}
            <div className="liti-card p-5 space-y-3 transition-all duration-300 hover:-translate-y-1">
              <div className="h-12 w-12 rounded-2xl bg-[#DCEEFF] text-[#6C54D8] flex items-center justify-center text-xl font-bold">
                💧
              </div>
              <h3 className="text-sm font-bold text-[#24152F]">Hidratação Diária</h3>
              <p className="text-xs text-[#6D6680] leading-relaxed">
                Marque cada copo de água ingerido durante o dia de forma prática e visualize a porcentagem da sua meta.
              </p>
            </div>

            {/* Card 3 */}
            <div className="liti-card p-5 space-y-3 transition-all duration-300 hover:-translate-y-1">
              <div className="h-12 w-12 rounded-2xl bg-[#ECE7FA] text-[#6C54D8] flex items-center justify-center text-xl font-bold">
                📊
              </div>
              <h3 className="text-sm font-bold text-[#24152F]">Peso & Medidas</h3>
              <p className="text-xs text-[#6D6680] leading-relaxed">
                Registre pesagens diárias ou semanais, acompanhe a redução de medidas corporais e compare sua evolução.
              </p>
            </div>

            {/* Card 4 */}
            <div className="liti-card p-5 space-y-3 transition-all duration-300 hover:-translate-y-1">
              <div className="h-12 w-12 rounded-2xl bg-[#CBF1DB] text-[#24152F] flex items-center justify-center text-xl font-bold">
                🧠
              </div>
              <h3 className="text-sm font-bold text-[#24152F]">Mente & MarIA Bot</h3>
              <p className="text-xs text-[#6D6680] leading-relaxed">
                Escreva no seu diário de bem-estar e conte com a assistente MarIA para organizar pensamentos e hábitos.
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* BANNER CTA FINAL DE ALTO IMPACTO */}
      <section className="py-16 px-4">
        <div className="mx-auto max-w-4xl rounded-[28px] bg-gradient-to-br from-[#6C54D8] via-[#5A45BF] to-[#24152F] p-8 sm:p-12 text-center text-white shadow-xl relative overflow-hidden">
          <div className="absolute -top-12 -left-12 h-44 w-44 rounded-full bg-[#CBF1DB]/20 blur-2xl pointer-events-none" />
          <div className="absolute -bottom-12 -right-12 h-44 w-44 rounded-full bg-[#6C54D8]/40 blur-2xl pointer-events-none" />

          <div className="relative z-10 space-y-5 max-w-2xl mx-auto">
            <h2 className="text-2xl sm:text-3xl font-bold tracking-tight font-serif">
              Pronto para ter um cuidado diário mais leve?
            </h2>
            <p className="text-xs sm:text-sm text-[#ECE7FA] font-medium leading-relaxed">
              Crie sua conta em menos de 1 minuto e comece a acompanhar sua saúde corporal e mental hoje mesmo.
            </p>
            <div className="pt-2">
              <Link
                to="/register"
                className="btn-primary bg-white text-[#24152F] hover:bg-[#ECE7FA] h-12 px-8 text-sm font-bold shadow-lg"
              >
                Criar Minha Conta Grátis
                <svg className="w-4 h-4 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="border-t border-[#ECE7FA] bg-white py-8">
        <div className="mx-auto max-w-6xl px-4 text-center sm:flex sm:items-center sm:justify-between">
          <div className="flex items-center justify-center gap-2 mb-4 sm:mb-0">
            <div className="flex h-7 w-7 items-center justify-center rounded-xl bg-[#6C54D8] text-white font-bold text-xs">
              m
            </div>
            <span className="text-sm font-bold text-[#24152F]">mariam</span>
          </div>

          <p className="text-xs text-[#6D6680] font-medium">
            © {new Date().getFullYear()} MariaM — Saúde, bem-estar e resultados reais.
          </p>

          <div className="mt-4 sm:mt-0 flex items-center justify-center gap-4 text-xs font-bold text-[#6C54D8]">
            <Link to="/login" className="hover:underline">Entrar</Link>
            <span>•</span>
            <Link to="/register" className="hover:underline">Cadastrar</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}